const isDevelopment = process.env.NODE_ENV === 'development';

export const ENDPOINT = isDevelopment ? 'http://localhost:3031' : 'https://server-eu-1.petapps.org/091d334e2bc5';
export const WEBSOCKET = isDevelopment ? 'http://localhost:3422' : 'https://server-eu-1.petapps.org';
export const WEBSOCKET_URL = isDevelopment ? undefined : '/4660e5de46f9/socket.io/';

const Urls = { ENDPOINT, WEBSOCKET, WEBSOCKET_URL };

export default Urls;
